export const colors = {
  blue: '#0069a6',
  blueLight: '#edf2f7',
  blueBright: '#0090e3',

  red: '#d9000b',
  darkRed: '#a74165',
  white: '#ffffff',
  offBlack: '#2e3033',
  grayLight: '#d8d8d8',
  grayMiddle: '#85898c',
  grayDark: '#494c4d',
  gray: '#CFCFCF',
  dataChanged: '#0099F2',
  coscoBlue: '#01508E',

  mocBrandPrimary: '#C33',
  mocTableHeaderBg: '#F8F8F8',
  mocControlItemBgActive: '#FFF2F0',
  mocText: 'rgba(0, 0, 0, 0.88)',
  mocTextSecondary: 'rgba(0, 0, 0, 0.65)',
  mocTextTertiary: 'rgba(0, 0, 0, 0.45)',
  mocBorders: 'rgba(0, 0, 0, 0.20)',
  mocColorInfoText: '#1677FF'
}

export const agCellStyle = {
  fontWeight: 400,
  fontSize: '14px',
  verticalAlign: "text-top",
  boxSizing: 'border-box'
}

export const presetCellStyles = {
  noWrapStyle: {whiteSpace: 'nowrap'},
  breakSpacesStyle: {whiteSpace: 'break-spaces'},
  redFont: {color: colors.red},
  redBoldFont: {color: colors.red, fontWeight: 600},
  grayLightFont: {color: colors.grayLight},
  blueFont: {color: colors.blue},
  bold: {fontWeight: 600},
  large: {minWidth: 300},
  medium: {minWidth: 160},
  small: {maxWidth: 50},
  small2: {maxWidth: 80},
  size120: {minWidth: 120},
  size140: {minWidth: 140},
  icon: {paddingTop: 16},
  thinRow: {padding: '10px 20px 10px 20px'},
  thinRowNoLeft: {padding: '10px 20px 10px 0px'},
  wrap: {whiteSpace: 'normal'},
  wordBreak: {wordBreak: 'break-word'},
  purpleFont: {color: colors.purple},
  tangerineFont: {color: colors.tangerine},
  greenFont: {color: colors.green},
  textAlignRight: {textAlign: 'right'},
  centerFlex: {display: 'flex', alignItems: 'center'},
  overflowVisible: {overflow: 'visible'}
}

export const normalTextStyle = {
  fontSize: 18,
  fontWeight: 'normal',
  color: colors.offBlack
}

export const mocNormalTextStyle = {
  fontSize: 14,
  fontStyle: 'nomal',
  fontWeight: '400',
  lineHeight: 1.5,
  color: colors.mocText
}

export const boldTextStyle = {
  fontSize: 18,
  fontWeight: 'bold',
  color: colors.offBlack
}

export const mocBoldTextStyle = {
  fontSize: 14,
  fontStyle: 'nomal',
  fontWeight: '700',
  lineHeight: 1.5,
  color: colors.mocText
}